/**
 * File: procturedCocumentController.js
 * Project: educore
 * Created Date: 2020-12-24
 * Author: Varun
 * Screen : 
 */
class ProcturedDocumentController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, CONSTANTS) {
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
    }
}
export default ProcturedDocumentController;


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/procturedDocumentsController.js